import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import { ref } from 'vue';
import ViewImage from './ViewImage.vue'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewPicture',
  props: ['image', 'alt'],
  setup(__props) {

const props = __props

const viewImageRef = ref()

const onPreview = () => {
  viewImageRef.value.open(props.image)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "preview-picture",
      onClick: onPreview
    }, [
      _createElementVNode("img", {
        src: props.image,
        alt: props.alt
      }, null, 8, _hoisted_1)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(ViewImage, {
        ref_key: "viewImageRef",
        ref: viewImageRef
      }, null, 512)
    ]))
  ], 64))
}
}

})